var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndrawReviewedDocsNeeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 540",
    width: 640,
    height: 540,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M626.62 493.38C626.62 493.38 626.62 493.38 626.62 493.38C626.62 494.46 626.62 495.06 626.62 495.18C626.62 495.18 626.62 495.18 626.62 495.18C515.29 495.18 453.44 495.18 441.07 495.18C441.07 495.18 441.07 495.18 441.07 495.18C441.07 494.1 441.07 493.5 441.07 493.38C441.07 493.38 441.07 493.38 441.07 493.38C552.4 493.38 614.25 493.38 626.62 493.38Z",
    id: "cLUxp9YCc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.62 242.59L562.31 256.25L568.52 231.41L553.62 230.17L553.62 230.17L553.62 242.59Z",
    id: "d264ZO6ZZq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.37 119.63C556.45 118.47 558.71 117.82 559.17 117.69C559.17 117.69 569.76 119.63 569.76 132.05C569.76 132.05 572.25 194.15 572.25 194.15C572 197.01 570.01 219.86 569.76 222.72C569.76 222.72 573.49 223.96 572.25 227.69C571 231.41 568.52 240.11 567.28 238.87C566.04 237.62 566.04 235.14 566.04 235.14C566.04 235.14 546.16 238.87 547.41 235.14C548.65 231.41 548.65 222.72 549.89 222.72C551.13 222.72 548.65 185.46 548.65 185.46C549.14 176.68 550.39 154.74 552.37 119.63Z",
    id: "c1jw8F2yE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.87 245.7L480.74 269.3L486.95 240.73L475.85 238.99L464.6 222.1L444.72 225.82L444.72 225.82L460.87 245.7Z",
    id: "a1WUsFisFf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.34 218.99C480.34 218.99 461.71 228.93 474.13 296C474.37 300.47 475.62 322.83 477.85 363.07L480.34 473.61L505.18 473.61L510.15 364.31L525.05 294.76L548.65 356.86L539.95 467.4L573.49 472.37L584.67 348.16L564.79 256.25L549.89 230.17L546.78 223.34C511.35 221.02 489.2 219.57 480.34 218.99Z",
    id: "b2uVpWJR6G"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.06 469.88C481.83 476.59 480.59 480.32 480.34 481.06C480.34 481.06 475.37 500.93 492.76 498.45C510.15 495.96 503.94 484.79 503.94 484.79C503.85 483.79 503.44 478.82 502.69 469.88L484.06 469.88Z",
    id: "d14bobg9ua"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.2 466.16C541.2 466.16 537.47 478.58 537.47 484.79C537.47 491 539.95 493.7 539.95 493.7C539.95 493.7 610.75 498.45 609.51 492.24C608.27 486.03 600.81 483.54 600.81 483.54C599.65 483.3 593.86 482.05 583.42 479.82L571 469.88L546.16 463.67C543.51 465 541.86 465.82 541.2 466.16Z",
    id: "cel6NIGc1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.63 41.38C499.6 41.38 489.03 51.95 489.03 64.98C489.03 78.02 499.6 88.58 512.63 88.58C525.66 88.58 536.23 78.02 536.23 64.98C536.23 51.95 525.66 41.38 512.63 41.38Z",
    id: "l4m1UTFTK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.74 109.7L525.05 125.84L503.93 102.24L501.45 82.37L530.02 74.92L530.02 74.92L533.74 109.7Z",
    id: "c1h3PptVzh"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.57 110.94L503.09 95.45L498.97 101L467.92 113.42C468.66 146.21 469.08 164.43 469.16 168.07C469.16 168.07 470.4 214.03 477.85 218.99C477.65 219.28 476.61 220.73 474.75 223.34L548.65 226.45L548.65 192.91L564.79 120.87L536.23 104.73L532.67 99.7L522.57 110.94Z",
    id: "b5RHUmDieA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.64 115.91L475.83 112.16C473.19 112.92 471.72 113.34 471.43 113.42C471.43 113.42 462.73 117.15 456.52 133.29C456.52 133.29 432.92 185.46 432.92 185.46C432.92 185.46 427.96 191.67 431.68 197.88C431.68 197.88 439.13 217.75 439.13 217.75C439.13 217.75 435.41 216.51 437.89 221.48C437.89 221.48 440.38 231.41 447.83 230.17C447.83 230.17 470.18 225.2 468.94 221.48C468.94 221.48 466.46 211.54 463.97 211.54C463.97 211.54 457.76 192.91 457.76 192.91C457.93 192.25 458.76 188.94 460.25 182.97L478.88 160.62L477.64 115.91Z",
    id: "a63x4l8Blj"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.39 46.35C511.39 46.35 498.4 45.96 493.09 51.74C487.79 57.53 489.03 48.84 489.03 48.84C489.03 48.84 475.37 42.63 486.55 36.42C486.67 36.54 487.66 37.53 487.79 37.66C487.79 37.66 490.27 33.93 498.97 32.69C498.84 32.57 497.85 31.57 497.73 31.45C497.73 31.45 497.73 30.21 503.94 30.21C503.94 30.21 526.29 24 527.53 37.66C527.53 37.66 537.47 33.93 537.47 46.35C537.47 58.77 536.23 64.98 536.23 64.98C536.23 64.98 533.74 58.77 528.78 62.5C523.81 66.22 515.11 47.59 515.11 47.59C514.37 47.35 511.39 47.59 511.39 46.35Z",
    id: "a5ywHdtj0o"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.24 445.42C205.24 450.9 162.29 455.33 109.31 455.33C56.33 455.33 13.38 450.9 13.38 445.42C13.38 439.95 56.33 435.51 109.31 435.51C162.29 435.51 205.24 439.95 205.24 445.42Z",
    id: "d83Gqplfx"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.5 300.94C167.5 300.94 167.5 300.94 167.5 300.94C167.5 387.66 167.5 435.83 167.5 445.47C167.5 445.47 167.5 445.47 167.5 445.47C97.67 445.47 58.87 445.47 51.11 445.47C51.11 445.47 51.11 445.47 51.11 445.47C51.11 358.75 51.11 310.57 51.11 300.94C51.11 300.94 51.11 300.94 51.11 300.94C120.95 300.94 159.75 300.94 167.5 300.94Z",
    id: "a3IlVEewlH"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.07 351.41C151.07 351.41 151.07 351.41 151.07 351.41C151.07 353.72 151.07 354.99 151.07 355.25C151.07 355.25 151.07 355.25 151.07 355.25C101.18 355.25 73.47 355.25 67.93 355.25C67.93 355.25 67.93 355.25 67.93 355.25C67.93 352.95 67.93 351.67 67.93 351.41C67.93 351.41 67.93 351.41 67.93 351.41C117.81 351.41 145.52 351.41 151.07 351.41Z",
    id: "cGiCjYTgb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.07 364.84C151.07 364.84 151.07 364.84 151.07 364.84C151.07 367.14 151.07 368.42 151.07 368.68C151.07 368.68 151.07 368.68 151.07 368.68C101.18 368.68 73.47 368.68 67.93 368.68C67.93 368.68 67.93 368.68 67.93 368.68C67.93 366.38 67.93 365.1 67.93 364.84C67.93 364.84 67.93 364.84 67.93 364.84C117.81 364.84 145.52 364.84 151.07 364.84Z",
    id: "b3woop2wUJ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.07 378.27C151.07 378.27 151.07 378.27 151.07 378.27C151.07 380.57 151.07 381.85 151.07 382.11C151.07 382.11 151.07 382.11 151.07 382.11C101.18 382.11 73.47 382.11 67.93 382.11C67.93 382.11 67.93 382.11 67.93 382.11C67.93 379.81 67.93 378.53 67.93 378.27C67.93 378.27 67.93 378.27 67.93 378.27C117.81 378.27 145.52 378.27 151.07 378.27Z",
    id: "d9l8zuSSt5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.07 391.7C151.07 391.7 151.07 391.7 151.07 391.7C151.07 394 151.07 395.28 151.07 395.54C151.07 395.54 151.07 395.54 151.07 395.54C101.18 395.54 73.47 395.54 67.93 395.54C67.93 395.54 67.93 395.54 67.93 395.54C67.93 393.24 67.93 391.96 67.93 391.7C67.93 391.7 67.93 391.7 67.93 391.7C117.81 391.7 145.52 391.7 151.07 391.7Z",
    id: "e83FE6yO"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.35 263.64C96.77 263.63 86.59 253.43 86.6 240.85C86.61 228.27 96.82 218.09 109.39 218.1C117.19 218.11 124.45 222.1 128.62 228.69C130.92 232.34 132.15 236.57 132.15 240.89C132.13 253.47 121.93 263.66 109.35 263.64Z",
    id: "mrI0hK0jb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.14 251.17C104.72 248.98 96.85 238.82 96.85 238.82C97.86 237.8 98.94 236.85 100.07 235.97C100.51 236.55 102.69 239.45 106.6 244.68C118.23 233.05 124.69 226.59 125.98 225.29C126.97 226.34 127.85 227.48 128.62 228.69C124.12 233.19 108.38 248.92 106.14 251.17Z",
    id: "bAGY6O3Ry"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.05 439.61C455.05 445.08 412.1 449.52 359.12 449.52C306.14 449.52 263.19 445.08 263.19 439.61C263.19 434.13 306.14 429.69 359.12 429.69C412.1 429.69 455.05 434.13 455.05 439.61Z",
    id: "d8uuqHSGK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.32 295.12C417.32 295.12 417.32 295.12 417.32 295.12C417.32 381.84 417.32 430.02 417.32 439.65C417.32 439.65 417.32 439.65 417.32 439.65C347.48 439.65 308.69 439.65 300.93 439.65C300.93 439.65 300.93 439.65 300.93 439.65C300.93 352.93 300.93 304.76 300.93 295.12C300.93 295.12 300.93 295.12 300.93 295.12C370.76 295.12 409.56 295.12 417.32 295.12Z",
    id: "b2dPR51hLJ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.88 375.58C400.88 375.58 400.88 375.58 400.88 375.58C400.88 377.88 400.88 379.16 400.88 379.41C400.88 379.41 400.88 379.41 400.88 379.41C351 379.41 323.29 379.41 317.74 379.41C317.74 379.41 317.74 379.41 317.74 379.41C317.74 377.11 317.74 375.83 317.74 375.58C317.74 375.58 317.74 375.58 317.74 375.58C367.63 375.58 395.34 375.58 400.88 375.58Z",
    id: "atQ9UP6kq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.88 389.01C400.88 389.01 400.88 389.01 400.88 389.01C400.88 391.31 400.88 392.59 400.88 392.84C400.88 392.84 400.88 392.84 400.88 392.84C351 392.84 323.29 392.84 317.74 392.84C317.74 392.84 317.74 392.84 317.74 392.84C317.74 390.54 317.74 389.26 317.74 389.01C317.74 389.01 317.74 389.01 317.74 389.01C367.63 389.01 395.34 389.01 400.88 389.01Z",
    id: "aodLLnkaE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.88 402.44C400.88 402.44 400.88 402.44 400.88 402.44C400.88 404.74 400.88 406.02 400.88 406.27C400.88 406.27 400.88 406.27 400.88 406.27C351 406.27 323.29 406.27 317.74 406.27C317.74 406.27 317.74 406.27 317.74 406.27C317.74 403.97 317.74 402.69 317.74 402.44C317.74 402.44 317.74 402.44 317.74 402.44C367.63 402.44 395.34 402.44 400.88 402.44Z",
    id: "a2je3V2eY"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.88 415.87C400.88 415.87 400.88 415.87 400.88 415.87C400.88 418.17 400.88 419.45 400.88 419.7C400.88 419.7 400.88 419.7 400.88 419.7C351 419.7 323.29 419.7 317.74 419.7C317.74 419.7 317.74 419.7 317.74 419.7C317.74 417.4 317.74 416.12 317.74 415.87C317.74 415.87 317.74 415.87 317.74 415.87C367.63 415.87 395.34 415.87 400.88 415.87Z",
    id: "ab6VKhMj9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.8 346.57C314.99 336.14 314.99 325.49 316.8 315.07C319.44 315.07 340.57 315.07 343.21 315.07C340.24 325.36 340.24 336.28 343.21 346.57C337.93 346.57 319.44 346.57 316.8 346.57Z",
    id: "cYZNF8DKF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.8 318.02C402.8 318.02 402.8 318.02 402.8 318.02C402.8 319.94 402.8 321.01 402.8 321.22C402.8 321.22 402.8 321.22 402.8 321.22C373.64 321.22 357.44 321.22 354.2 321.22C354.2 321.22 354.2 321.22 354.2 321.22C354.2 319.3 354.2 318.23 354.2 318.02C354.2 318.02 354.2 318.02 354.2 318.02C383.36 318.02 399.56 318.02 402.8 318.02Z",
    id: "bemtengit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.8 329.53C402.8 329.53 402.8 329.53 402.8 329.53C402.8 331.45 402.8 332.52 402.8 332.73C402.8 332.73 402.8 332.73 402.8 332.73C373.64 332.73 357.44 332.73 354.2 332.73C354.2 332.73 354.2 332.73 354.2 332.73C354.2 330.81 354.2 329.75 354.2 329.53C354.2 329.53 354.2 329.53 354.2 329.53C383.36 329.53 399.56 329.53 402.8 329.53Z",
    id: "dDUtHQfU2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.8 341.04C402.8 341.04 402.8 341.04 402.8 341.04C402.8 342.96 402.8 344.03 402.8 344.24C402.8 344.24 402.8 344.24 402.8 344.24C373.64 344.24 357.44 344.24 354.2 344.24C354.2 344.24 354.2 344.24 354.2 344.24C354.2 342.32 354.2 341.26 354.2 341.04C354.2 341.04 354.2 341.04 354.2 341.04C383.36 341.04 399.56 341.04 402.8 341.04Z",
    id: "a3EqyWcMAh"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.8 352.55C402.8 352.55 402.8 352.55 402.8 352.55C402.8 354.47 402.8 355.54 402.8 355.75C402.8 355.75 402.8 355.75 402.8 355.75C373.64 355.75 357.44 355.75 354.2 355.75C354.2 355.75 354.2 355.75 354.2 355.75C354.2 353.83 354.2 352.77 354.2 352.55C354.2 352.55 354.2 352.55 354.2 352.55C383.36 352.55 399.56 352.55 402.8 352.55Z",
    id: "bLgPBPL0i"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.16 258.58C346.59 258.57 336.4 248.36 336.41 235.78C336.43 223.21 346.63 213.02 359.21 213.03C367.01 213.04 374.26 217.04 378.43 223.63C380.74 227.28 381.96 231.51 381.96 235.83C381.95 248.4 371.74 258.59 359.16 258.58Z",
    id: "a1x3vK9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.95 246.1C354.54 243.92 346.67 233.75 346.67 233.75C347.67 232.73 348.75 231.78 349.89 230.91C350.32 231.49 352.5 234.39 356.42 239.61C368.04 227.98 374.51 221.52 375.8 220.23C376.78 221.28 377.66 222.41 378.43 223.63C373.93 228.12 358.2 243.86 355.95 246.1Z",
    id: "b2XEeRbRMB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.82 499.59C347.82 506 297.49 511.2 235.4 511.2C173.31 511.2 122.97 506 122.97 499.59C122.97 493.17 173.31 487.97 235.4 487.97C297.49 487.97 347.82 493.17 347.82 499.59Z",
    id: "a8i8RbvqU"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.85 332.82C302.85 332.82 302.85 332.82 302.85 332.82C302.85 434.45 302.85 490.92 302.85 502.21C302.85 502.21 302.85 502.21 302.85 502.21C221.01 502.21 175.54 502.21 166.44 502.21C166.44 502.21 166.44 502.21 166.44 502.21C166.44 400.58 166.44 344.11 166.44 332.82C166.44 332.82 166.44 332.82 166.44 332.82C248.29 332.82 293.76 332.82 302.85 332.82Z",
    id: "dnioJHftw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.37 368.8C283.37 368.8 283.37 368.8 283.37 368.8C283.37 371.5 283.37 372.99 283.37 373.29C283.37 373.29 283.37 373.29 283.37 373.29C224.91 373.29 192.43 373.29 185.93 373.29C185.93 373.29 185.93 373.29 185.93 373.29C185.93 370.6 185.93 369.1 185.93 368.8C185.93 368.8 185.93 368.8 185.93 368.8C244.39 368.8 276.87 368.8 283.37 368.8Z",
    id: "bzg8m87j2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.37 384.54C283.37 384.54 283.37 384.54 283.37 384.54C283.37 387.24 283.37 388.73 283.37 389.03C283.37 389.03 283.37 389.03 283.37 389.03C224.91 389.03 192.43 389.03 185.93 389.03C185.93 389.03 185.93 389.03 185.93 389.03C185.93 386.34 185.93 384.84 185.93 384.54C185.93 384.54 185.93 384.54 185.93 384.54C244.39 384.54 276.87 384.54 283.37 384.54Z",
    id: "frU3oUsdQ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.37 400.28C283.37 400.28 283.37 400.28 283.37 400.28C283.37 402.97 283.37 404.47 283.37 404.77C283.37 404.77 283.37 404.77 283.37 404.77C224.91 404.77 192.43 404.77 185.93 404.77C185.93 404.77 185.93 404.77 185.93 404.77C185.93 402.08 185.93 400.58 185.93 400.28C185.93 400.28 185.93 400.28 185.93 400.28C244.39 400.28 276.87 400.28 283.37 400.28Z",
    id: "f2sS6H6VAn"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.37 416.02C283.37 416.02 283.37 416.02 283.37 416.02C283.37 418.71 283.37 420.21 283.37 420.51C283.37 420.51 283.37 420.51 283.37 420.51C224.91 420.51 192.43 420.51 185.93 420.51C185.93 420.51 185.93 420.51 185.93 420.51C185.93 417.81 185.93 416.32 185.93 416.02C185.93 416.02 185.93 416.02 185.93 416.02C244.39 416.02 276.87 416.02 283.37 416.02Z",
    id: "e7PaA3b0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.37 431.76C283.37 431.76 283.37 431.76 283.37 431.76C283.37 434.45 283.37 435.95 283.37 436.25C283.37 436.25 283.37 436.25 283.37 436.25C224.91 436.25 192.43 436.25 185.93 436.25C185.93 436.25 185.93 436.25 185.93 436.25C185.93 433.55 185.93 432.06 185.93 431.76C185.93 431.76 185.93 431.76 185.93 431.76C244.39 431.76 276.87 431.76 283.37 431.76Z",
    id: "gfvRQds8X"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.13 448.24C260.13 448.24 260.13 448.24 260.13 448.24C260.13 459.04 260.13 465.03 260.13 466.23C260.13 466.23 260.13 466.23 260.13 466.23C229.55 466.23 212.56 466.23 209.17 466.23C209.17 466.23 209.17 466.23 209.17 466.23C209.17 455.44 209.17 449.44 209.17 448.24C209.17 448.24 209.17 448.24 209.17 448.24C239.75 448.24 256.73 448.24 260.13 448.24Z",
    id: "a40pt7DQw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.11 294.22C216.21 294.21 200.9 278.87 200.92 259.97C200.94 241.07 216.27 225.76 235.17 225.78C246.89 225.79 257.79 231.8 264.06 241.7C267.53 247.19 269.37 253.55 269.36 260.04C269.35 278.94 254.01 294.24 235.11 294.22Z",
    id: "b4IHWMRIz0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.28 275.48C228.16 272.19 216.33 256.92 216.33 256.92C217.84 255.38 219.46 253.96 221.17 252.64C221.82 253.51 225.09 257.87 230.98 265.72C248.45 248.24 258.16 238.54 260.1 236.59C261.58 238.17 262.91 239.88 264.06 241.7C264.06 241.7 233.66 272.1 230.28 275.48Z",
    id: "bLvn7DEEE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cLUxp9YCc",
    opacity: 1,
    fill: "#3f3d56",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cLUxp9YCc",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d264ZO6ZZq",
    opacity: 1,
    fill: "#a0616a",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d264ZO6ZZq",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1jw8F2yE2",
    opacity: 1,
    fill: "#e6e6e6",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1jw8F2yE2",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1WUsFisFf",
    opacity: 1,
    fill: "#a0616a",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1WUsFisFf",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2uVpWJR6G",
    opacity: 1,
    fill: "#2f2e41",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2uVpWJR6G",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d14bobg9ua",
    opacity: 1,
    fill: "#2f2e41",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d14bobg9ua",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cel6NIGc1",
    opacity: 1,
    fill: "#2f2e41",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cel6NIGc1",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l4m1UTFTK",
    opacity: 1,
    fill: "#a0616a",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l4m1UTFTK",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1h3PptVzh",
    opacity: 1,
    fill: "#a0616a",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1h3PptVzh",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b5RHUmDieA",
    opacity: 1,
    fill: "#e6e6e6",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b5RHUmDieA",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a63x4l8Blj",
    opacity: 1,
    fill: "#e6e6e6",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a63x4l8Blj",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a5ywHdtj0o",
    opacity: 1,
    fill: "#2f2e41",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a5ywHdtj0o",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d83Gqplfx",
    opacity: 1,
    fill: "#e6e6e6",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d83Gqplfx",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a3IlVEewlH",
    opacity: 1,
    fill: "#e6e6e6",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a3IlVEewlH",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cGiCjYTgb",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cGiCjYTgb",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b3woop2wUJ",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b3woop2wUJ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d9l8zuSSt5",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d9l8zuSSt5",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e83FE6yO",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e83FE6yO",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mrI0hK0jb",
    opacity: 1,
    fill: "#e6e6e6",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mrI0hK0jb",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bAGY6O3Ry",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bAGY6O3Ry",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d8uuqHSGK",
    opacity: 1,
    fill: "#e6e6e6",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d8uuqHSGK",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2dPR51hLJ",
    opacity: 1,
    fill: "#e6e6e6",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2dPR51hLJ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#atQ9UP6kq",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#atQ9UP6kq",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aodLLnkaE",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aodLLnkaE",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2je3V2eY",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2je3V2eY",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ab6VKhMj9",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ab6VKhMj9",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cYZNF8DKF",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cYZNF8DKF",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bemtengit",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bemtengit",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dDUtHQfU2",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dDUtHQfU2",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a3EqyWcMAh",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a3EqyWcMAh",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bLgPBPL0i",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bLgPBPL0i",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1x3vK9",
    opacity: 1,
    fill: "#e6e6e6",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1x3vK9",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2XEeRbRMB",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2XEeRbRMB",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a8i8RbvqU",
    opacity: 1,
    fill: "#3f3d56",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a8i8RbvqU",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dnioJHftw",
    opacity: 1,
    fill: "#f6841f",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dnioJHftw",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bzg8m87j2",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bzg8m87j2",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#frU3oUsdQ",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#frU3oUsdQ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f2sS6H6VAn",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f2sS6H6VAn",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e7PaA3b0A",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e7PaA3b0A",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gfvRQds8X",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gfvRQds8X",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a40pt7DQw",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a40pt7DQw",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b4IHWMRIz0",
    opacity: 1,
    fill: "#f6841f",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b4IHWMRIz0",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bLvn7DEEE",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bLvn7DEEE",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawReviewedDocsNeeb);
export default __webpack_public_path__ + "static/media/undraw_reviewed_docs_neeb.48e3fdf00a8e5c6dfcaa7c99c9166c9e.svg";
export { ForwardRef as ReactComponent };